import React, { useState, useEffect, useRef, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Redirect, useHistory } from 'react-router-dom';
import { toEN } from '../../fns/toEn';
import { store } from '../../store';
import axios from '../../api/axios';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 550,
    padding: theme.spacing(2),
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  timer: {
    textAlign: 'right',
    fontSize: 25,
    fontWeight: 'bold',
  },
}));

const Verify = () => {
  useTitle('کد تایید');
  const classes = useStyles();
  const { showMessage, showError, dispatch } = useContext(store);
  const userId = sessionStorage.getItem('userId');
  const expireTime = sessionStorage.getItem('expireTime');
  const initialTime = Math.floor((expireTime * 1 - Date.now()) / 1000);
  const [remainTime, setRemainTime] = useState(initialTime);
  const [verificationCode, setVerificationCode] = useState('');
  const interval = useRef();
  const history = useHistory();
  const inputRef = useRef(null);

  const handleChangeTF = (e) => {
    let { value } = e.target;
    value = toEN(value);
    if (value?.length > 5) return;
    setVerificationCode(value);
  };
  const verifyCode = async () => {
    try {
      const { data } = await axios.post(`/auth/user/verifyAdmin`, {
        verificationCode,
        userId,
      });
      if (data?.ok) {
        const { refreshToken, accessToken } = data;
        accessToken &&
          localStorage.setItem('@footab/admin/accessToken', accessToken);
        refreshToken &&
          localStorage.setItem('@footab/admin/refreshToken', refreshToken);
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('expireTime');
        dispatch({ type: 'AUTH', payload: true, action: 'LOGIN' });
      }
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    inputRef.current.focus();

    interval.current = setInterval(() => {
      setRemainTime((prev) => prev - 1);
    }, 1000);
  }, []);

  useEffect(() => {
    if (remainTime === 0) {
      clearInterval(interval.current);
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('expireTime');
      history.replace('/login');
    }
  }, [remainTime]);

  useEffect(() => {
    if (verificationCode?.length === 5) verifyCode();
  }, [verificationCode]);

  if (!userId) return <Redirect to="/login" />;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div>لطفا کد تائید ارسالی به موبایل خود را وارد نمایید:</div>
        <TextField
          inputRef={inputRef}
          value={verificationCode || ''}
          onChange={handleChangeTF}
          variant="outlined"
          size="medium"
          label="کد تایید"
          fullWidth
        />
        <div className={classes.timer}>{remainTime}</div>
      </Paper>
    </div>
  );
};

export default React.memo(Verify);
